import { createContext, useReducer } from 'react'
import { type LocationProviderProps, type LocationDataContextProps, type LocationDispatchContextProps, type Location } from 'src/types'

import { reducer } from './reducer'

/* TEMP */
const locationData: Record<string, Location> = {}

export const LocationDataContext = createContext<LocationDataContextProps>({ locations: locationData })
LocationDataContext.displayName = 'LocationDataContext'

export const LocationDispatchContext = createContext<LocationDispatchContextProps>({ dispatchLocations: () => null })
LocationDispatchContext.displayName = 'LocationDispatchContext'

export const LocationProvider = ({ children }: LocationProviderProps) => {
  const [locations, dispatchLocations] = useReducer(reducer, locationData)
 
  return (
    <LocationDataContext.Provider value={{ locations}}>
      <LocationDispatchContext.Provider value={{ dispatchLocations }}>
        {children}
      </LocationDispatchContext.Provider>
    </LocationDataContext.Provider>
    
  )
}
